/* eslint-disable complexity */
/* eslint-disable max-lines */
import React, { Component } from 'react';
import { string, shape, number, func, object, bool, array, oneOfType } from 'prop-types';
import { t } from 'i18next';
import cn from 'classnames';

import AddressConfirm from '~screens/Dashboard/components/ChangeAddress/components/AddressConfirm';
import { DISPATCH_METHODS } from '~constants/address';
import FormWrapper from '~components/FormWrapper';
import InputLabel from '~components/InputLabel';
import Field from '~components/Field/index';
import SectionTitle from '~components/SectionTitle';
import { googleAddressPropTypes } from '~propTypes/address';
import LoadingSpinner from '~components/loadingSpinner';
import CustomButton from '~components/CustomButton';
import { RENDER_CALL_CENTER } from '~constants/environment';
import Dropdown from '~components/Dropdown';
import Checkbox from '~components/Checkbox';
import LocalStorageService from '~services/LocalStorageService';
import {
  MAP_SELECTION_ENABLED,
  DEFAULT_MAX_RESULTS
} from '~screens/Dashboard/components/ChangeAddress/constants';
import StoreSearchBar from '~components/StoreSearchBar';

// eslint-disable-next-line import/order
import { TABS_DATA } from '../../constants';

import SearchAddressMap from '~screens/Dashboard/components/ChangeAddress/components/SearchAddressMap';

import AddressWarningBanner from './components/AddressWarningBanner';
import { BUILDING_TYPE_OPTIONS, FIELDS } from './constants';
import styles from './styles.module.scss';
import StoreInfo from './components/StoreInfo';
import { validationSchema } from './utils';

class Delivery extends Component {
  state = {
    saveAddress: false,
    buildingType: BUILDING_TYPE_OPTIONS[0],
    selectedTime: null
  };

  componentDidMount = () => {
    const { onDispatchChange, searchStore, setSelectedDeliveryTime, deliveryInfo, selectedDeliveryTime } =
      this.props;
    const now = {
      now: t('Delivery:time', { time: searchStore.currentSubsidiary.deliveryWaitTime })
    };
    if (deliveryInfo?.deliveryOpen) {
      setSelectedDeliveryTime(now);
    }
    onDispatchChange(DISPATCH_METHODS.PJ_DELIVERY);
    if (searchStore?.dispatchType === DISPATCH_METHODS.PJ_DELIVERY) {
      this.handleSelectedTime(deliveryInfo?.deliveryOpen ? now : selectedDeliveryTime);
    }
  };

  handleSubmit = values => {
    const {
      onConfirm,
      deliveryInfo,
      userAddresses,
      editUserAddress,
      createUserAddress,
      setSelectedDeliveryTime
    } = this.props;
    const { saveAddress, buildingType, selectedTime } = this.state;
    if (saveAddress) {
      const isExistingAddress = userAddresses?.find(({ kind }) => kind === buildingType.type);
      const { apartmentDetails, dispatchNote } = values;
      const addressValue = {
        ...values,
        apartmentDetails: apartmentDetails ?? '',
        dispatchNote: dispatchNote ?? ''
      };
      if (isExistingAddress) {
        editUserAddress(addressValue, isExistingAddress.id);
      } else {
        createUserAddress({ ...addressValue, kind: buildingType.type });
      }
    }

    if (selectedTime?.time?.name) {
      LocalStorageService.setSelectedDeliveryTime(selectedTime, '', 60);
    } else {
      LocalStorageService.removeSelectedDeliveryTime();
    }

    setSelectedDeliveryTime(selectedTime);

    onConfirm({ store: deliveryInfo, addressDetails: values, type: DISPATCH_METHODS.PJ_DELIVERY });
  };

  handleChangeToInStore = () => {
    const { changeTab, onDispatchChange } = this.props;
    const inStoreIndex = TABS_DATA.findIndex(tab => tab.value === DISPATCH_METHODS.IN_STORE);
    onDispatchChange(DISPATCH_METHODS.IN_STORE);
    changeTab(inStoreIndex);
  };

  // eslint-disable-next-line class-methods-use-this
  showWarningAdress = selectedAddress =>
    selectedAddress &&
    !selectedAddress?.hasStreetNumber && (
      <AddressWarningBanner description={t('ChangeAddress:completeAddressWarning')} />
    );

  handleSaveAddress = () => {
    const { saveAddress } = this.state;
    this.setState({ saveAddress: !saveAddress });
  };

  // eslint-disable-next-line class-methods-use-this
  handleChangeBuildingType = event => {
    const buildingType = BUILDING_TYPE_OPTIONS.find(({ value }) => event.target.value === value);
    this.setState({ buildingType });
  };

  handleSelectedTime = time => {
    this.setState({ selectedTime: time });
  };

  handleCleanAddress = () => {
    const { onSearchInputChange, undoConfirmAddress } = this.props;
    onSearchInputChange();
    undoConfirmAddress();
  };

  render() {
    const {
      className,
      deliveryInfo,
      selectedAddress,
      futureOrdersEnabled,
      goToCheckout,
      logged,
      isConfirmAddress,
      withConfirmAddressFlow,
      onAddressSelect,
      onSearchInputChange,
      incompleteAddress,
      onMarkerDragEnd,
      onConfirmAddress,
      scheduled,
      setScheduled
    } = this.props;

    const { selectedTime } = this.state;

    const textButtonWithConfirm = isConfirmAddress
      ? t('Delivery:withConfirmAddressButton')
      : t('Delivery:confirmButton');
    const textButton = goToCheckout ? t('Delivery:confirmAndGoToCheckoutBtn') : textButtonWithConfirm;

    const showDeliveryData = withConfirmAddressFlow ? isConfirmAddress : true;

    return (
      <>
        {withConfirmAddressFlow && !isConfirmAddress && (
          <AddressConfirm
            onAddressSelect={onAddressSelect}
            incompleteAddress={incompleteAddress}
            isConfirmAddress={isConfirmAddress}
            selectedAddress={selectedAddress}
            onConfirmAddress={onConfirmAddress}
            onMarkerDragEnd={onMarkerDragEnd}
            onSearchInputChange={onSearchInputChange}
          />
        )}
        {withConfirmAddressFlow && isConfirmAddress && selectedAddress && (
          <>
            <div className={styles.addressSubtitle}>{t('ChangeAddress:addressSubtitle')}</div>
            {selectedAddress ? (
              <div className={styles.addressTitle}>
                {selectedAddress.description || selectedAddress.formattedAddress}
              </div>
            ) : null}
            <div>
              <CustomButton
                className={cn(styles.addressButton, 'm-bottom-2')}
                type="button"
                btnClassType="link"
                onClick={this.handleCleanAddress}>
                {t('ChangeAddress:changeAddress')}
              </CustomButton>
            </div>
          </>
        )}
        {!withConfirmAddressFlow && (
          <>
            {MAP_SELECTION_ENABLED ? (
              <div className="full-width m-bottom-6">
                <SearchAddressMap currentAddress={selectedAddress} onMarkerDragEnd={onMarkerDragEnd} />
              </div>
            ) : null}
            <div className="full-width m-bottom-4">
              <StoreSearchBar
                key="modalSearchBar"
                maxResults={DEFAULT_MAX_RESULTS}
                selectedAddress={selectedAddress}
                onAddressSelect={onAddressSelect}
                onChange={onSearchInputChange}
                onClean={this.handleCleanAddress}
                incompleteAddress={incompleteAddress}
                placeholder={t('Delivery:searchPlaceholder')}
              />
            </div>
            {this.showWarningAdress(selectedAddress)}
          </>
        )}
        {showDeliveryData && selectedAddress && selectedAddress.hasStreetNumber && (
          <FormWrapper
            onSubmit={this.handleSubmit}
            initialValues={selectedAddress}
            validationSchema={validationSchema}
            validateOnBlur
            avoidErrorUntilSubmit>
            {({ isSubmitting, handleSubmit }) => (
              <form className={`column full-width ${styles.deliveryForm}`} onSubmit={handleSubmit}>
                <div className={cn(`full-width ${className}`, { [styles.content]: RENDER_CALL_CENTER })}>
                  <div className="ps-relative super-z">
                    <StoreInfo
                      futureOrdersEnabled={futureOrdersEnabled}
                      deliveryInfo={deliveryInfo}
                      selectedAddress={selectedAddress}
                      onSelectedTime={this.handleSelectedTime}
                      selectedTime={selectedTime}
                      setScheduled={setScheduled}
                    />
                  </div>
                  <SectionTitle title={t('Delivery:description')} titleClassName={styles.sectionTitle} />
                  <div
                    className={cn('row m-bottom-4', styles.inputs, styles.container, {
                      [styles.inputsContainer]: RENDER_CALL_CENTER,
                      [styles.containerWithSaveAddress]: logged
                    })}>
                    <Field
                      name={FIELDS.apartment}
                      component={InputLabel}
                      className={cn('item-1')}
                      label={t('Delivery:apartmentPlaceholder')}
                      placeholder={t('Delivery:placeholder')}
                      inputContainerClassName={styles.inputContainer}
                    />
                    <Field
                      name={FIELDS.note}
                      component={InputLabel}
                      inputType="text"
                      className={cn('item-1', styles.textareaAddress)}
                      label={t('Delivery:notePlaceholder')}
                      placeholder={t('Delivery:notePlaceholderEx')}
                      helperText={t('Delivery:noteHelperText')}
                      inputContainerClassName={styles.inputContainer}
                    />
                  </div>
                  {logged && (
                    <div
                      className={cn('row middle center m-bottom-4', styles.containerSaveAddress, {
                        [styles.inputsContainer]: RENDER_CALL_CENTER
                      })}>
                      <Checkbox
                        label={t('Delivery:saveAddress')}
                        className={cn('item-1 m-bottom-2', styles.checkbox, {
                          [styles.checkboxChecked]: this.state.saveAddress
                        })}
                        isChecked={this.state.saveAddress}
                        onChange={this.handleSaveAddress}
                      />
                      {this.state.saveAddress && (
                        <div className={cn('column fullWidth item-1 m-left-4', styles.dropdownContainer)}>
                          <span className={cn('m-bottom-2', styles.dropdownLabel)}>
                            {t('Delivery:buildingType')}
                          </span>
                          <Dropdown
                            className={cn('full-width row', styles.containerBuildingType)}
                            options={BUILDING_TYPE_OPTIONS}
                            value={this.state.buildingType.value}
                            onChange={this.handleChangeBuildingType}
                            labelClassname={cn('middle', styles.optionLabel)}
                            optionContainerClassName={styles.containerBuildingTypeOptions}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div
                  className={cn(`column middle center ${styles.footer}`, {
                    [styles.callCenterFooter]: RENDER_CALL_CENTER
                  })}>
                  {futureOrdersEnabled && scheduled && !selectedTime && (
                    <span className={cn('m-bottom-2', styles.warningSelectTime)}>
                      {t('Delivery:chooseATime')}
                    </span>
                  )}
                  <CustomButton
                    id="button-confirm-pickup"
                    buttonType="button"
                    onClick={this.handleConfirm}
                    btnClassType="primary"
                    className={styles.confirmButton}
                    fullWidth
                    disabled={futureOrdersEnabled && scheduled && !selectedTime}>
                    <LoadingSpinner classNames="m-right-1 m-left-1" isVisible={isSubmitting} />
                    {textButton}
                  </CustomButton>
                </div>
              </form>
            )}
          </FormWrapper>
        )}
      </>
    );
  }
}

Delivery.propTypes = {
  onAddressSelect: func.isRequired,
  onConfirm: func.isRequired,
  changeTab: func,
  className: string,
  createUserAddress: func,
  deliveryInfo: shape({
    name: string,
    deliveryWaitTime: number,
    menuId: number
  }),
  editUserAddress: func,
  futureOrdersEnabled: bool,
  goToCheckout: bool,
  incompleteAddress: oneOfType([string, undefined]),
  isConfirmAddress: bool,
  logged: bool,
  scheduled: bool,
  searchStore: object,
  selectedAddress: googleAddressPropTypes,
  selectedDeliveryTime: object,
  setScheduled: func,
  setSelectedDeliveryTime: func,
  undoConfirmAddress: func,
  userAddresses: array,
  withConfirmAddressFlow: bool,
  onConfirmAddress: func,
  onDispatchChange: func,
  onMarkerDragEnd: func,
  onSearchInputChange: func
};

export default Delivery;
